import {createAction} from 'redux-act';

export const GET_INVITE_A_BITE_INFO = createAction(
  'inviteABite/GET_INVITE_A_BITE_INFO'
);
export const GET_INVITE_A_BITE_INFO_SUCCESS = createAction(
  'inviteABite/GET_INVITE_A_BITE_INFO_SUCCESS'
);
export const SET_LOADING = createAction('inviteABite/SET_LOADING');
export const CLEAR_INVITE_A_BITE_DATA = createAction(
  'inviteABite/CLEAR_INVITE_A_BITE_DATA'
);
